import type { EndSessionRequest, IPublicClientApplication } from '@azure/msal-browser';

export function createBackofficeLogoutRequest(): EndSessionRequest {
  return {};
}

export async function logoutBackoffice(instance: IPublicClientApplication): Promise<void> {
  await instance.logoutRedirect(createBackofficeLogoutRequest());
}
